import Constants from "../../utils/CommonConstants";

const routes = [{
    name: Constants.RoutingStates.ABOUT,
    url: '/about',
    views: {
        contents: {
            template: require('./views/about.jade'),
            controller: 'Cartonomy.About.AboutController'
        }
    }
}];

export default routes;


// WEBPACK FOOTER //
// ./src/modules/about/routeConfig.js